/**
 * 判断两个 Puppy CAD 内核 Shape 是否表示同一个带定位与方向的拓扑项。
 *
 * 仅使用 `IsSame`，因为 `IsPartner` 会忽略 Location 和 Orientation，可能把拉伸体
 * 上共享 TShape 的底面项与顶面项错误合并，进而破坏权威拓扑编号。
 *
 * @param left 左侧 Puppy CAD 内核 Shape。
 * @param right 右侧 Puppy CAD 内核 Shape。
 * @returns 两个 Shape 是否为同一个拓扑项。
 */
export function arePuppyShapesSame(left: unknown, right: unknown): boolean {
  if (left === right) {
    return true;
  }
  const isSame = (left as Record<string, unknown> | null)?.IsSame;
  if (typeof isSame !== 'function') {
    return false;
  }
  try {
    return Boolean(isSame.call(left, right));
  } catch {
    return false;
  }
}

/**
 * 按 Puppy CAD 内核 拓扑同一性去重 Shape，并保持首次枚举顺序。
 *
 * 权威快照与 Worker 特征求解必须复用此规则，避免同一物理拓扑项在两侧获得不同索引。
 *
 * @param shapes Puppy CAD 内核 Shape 集合。
 * @returns 保持首次出现顺序的去重集合。
 */
export function deduplicatePuppyShapes(shapes: unknown[]): unknown[] {
  return shapes.filter((shape, index) => (
    shapes.findIndex((candidate) => arePuppyShapesSame(candidate, shape)) === index
  ));
}
